import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-plate-number-view',
  templateUrl: './plate-number-view.component.html',
  styleUrls: ['./plate-number-view.component.scss'],
})
export class PlateNumberViewComponent {
  parsedPlateNumber: any;
  @Input() plateNumber: string;
  @Input() isExternal: boolean;
  @Input() set plateNumberDetails(value: string) {
    const parsedPlateNumber = JSON.parse(value);
    if (parsedPlateNumber) {
      parsedPlateNumber.plateNumberDigitsAR = (parsedPlateNumber?.plateNumberDigits?.toString() || '')
        .split('')
        .map((n) => this.arabicNumbers[n])
        .join('');
    }
    this.parsedPlateNumber = parsedPlateNumber;
  }

  private arabicNumbers = {
    0: '٠',
    1: '١',
    2: '٢',
    3: '٣',
    4: '٤',
    5: '٥',
    6: '٦',
    7: '٧',
    8: '٨',
    9: '٩',
  };
}
